import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { Preloader } from '@/components/Preloader';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { useGetFundraisingStatusById } from '@/query/queries/fundraising/useGetFundraisingStatusById';
import { useApplicationStatusByFundraisingId } from '@/hooks/shared/useApplicationStatusByFundraisingId';
import { FundraisingGoalStructure } from '../FundraisingGoalStructure';
import { BorrowerFundraisingInfo } from '../BorrowerFundraisingInfo';

export const BorrowerFundraisingDetail = ({ selectedApplication, onBack }) => {
  const fundraisingId = selectedApplication.fundraising_id;
  const { user } = useGetMe();
  const { application } = useApplicationStatusByFundraisingId(fundraisingId);
  const { data: status } = useGetFundraisingStatusById(fundraisingId)

  if (!selectedApplication || !user || !application)
    return (
      <div className="container-inner">
        <Preloader style={{ height: '40vh' }} />
      </div>
    );

  if (application.status === null || application.status === FR_APPLICATION_STATUSES.NEW) {
    return <FundraisingGoalStructure selectedApplication={selectedApplication} onBack={onBack} />;
  }

  if (!status) return null;

  return (
    <BorrowerFundraisingInfo
      fundraisingId={fundraisingId}
      application={application}
      onBack={onBack}
    />
  );
};
